import style from './ProjectItem.module.scss';
import className from 'classnames/bind';
import {StatusLabel, Button, Icon} from "~/components";
import { useCan } from "~/hooks";
import _ from "lodash";
import ProjectTask from "./ProjectTask";

const cn = className.bind(style);

function ProjectItem({project = [], filter, setItemEdit, setProject, openModal}) {

	const can = {
		add: useCan('taskAdd'),
		edit: useCan('taskEdit'),
		status: useCan('taskStatus'),
		assign: useCan('projectAssign'),
		phase: useCan('projectPhase'),
		delete: useCan('projectDelete'),
	};

	const handleButtonClick = {
		add: (project) => {
			setProject(project);
			openModal('add');
		},
	}

	return (
		<div className="content">
			<div className={cn('project-info')+ ' d-flex align-items gap justify-content-between'}>
				<div className={cn('project-heading')}>
					<StatusLabel type="green">{project.contract.code}</StatusLabel>
					<StatusLabel type="blue">{project.contract.domain}</StatusLabel>
					<span className={cn('name')}>{project.contract.name}</span>
					<StatusLabel small type={project.phase.badge}>{project.phase.label}</StatusLabel>
					<StatusLabel small background type={'red'}>{project.unfinishedTask}</StatusLabel>
				</div>
				<div>
					{can.add && <Button small outline leftIcon={Icon.plusCircle} onClick={() => handleButtonClick.add(project)}>Thêm mới</Button>}
				</div>
			</div>
			<div className={cn('project-task')}>
				<ProjectTask project={project}
							 filter={filter}
							 can={can}
							 setItemEdit={setItemEdit}
							 setProject={setProject}
							 openModal={openModal} />
			</div>
		</div>
	)
}

export default ProjectItem